/* eslint no-param-reassign: 0 */
import SkiPassCartItem from '@/classes/SkiPassCartItem';
import ProductCartItem from '@/classes/ProductCartItem';
import { refreshCart } from '@/store-methods/mutations/accomodation';

export const addSkiPassPeople = ($, payload) => {
  if (!payload.append) {
    $.cart.skipasses = $.cart.skipasses.filter(skipass => skipass.type === 'SKIPASS-ACCO');
  }

  let i = 0;
  while (i < payload.peopleCount) {
    const item = new SkiPassCartItem();
    item.days = payload.numberOfDays;
    item.quantity = 1;

    $.cart.skipasses.push(item);
    i += 1;
  }

  // $.cart.currentRentalIndex = 0;
};

export const updateSkiPassPerson = ($, payload) => {
  const index = parseInt(payload.index, 10);

  let indexToUpdate = -1;
  let iterator = -1;
  $.cart.skipasses.forEach((skipass, i) => {
    if (skipass.type !== 'SKIPASS-ACCO') {
      iterator += 1;

      if (iterator === index) {
        indexToUpdate = i;
      }
    }
  });


  const item = $.cart.skipasses[indexToUpdate];
  item.age = payload.age;
  item.days = payload.days;
  item.price = payload.price;
  item.title = payload.title;
  item.guideCompleted = payload.guideCompleted;
  item.guideFullyCompleted = payload.guideFullyCompleted;
  item.completed = payload.completed;
  item.refill = payload.refill;
  item.cardNumber = payload.keycardNumber;
  item.cardPrefix = payload.keycardNumberPrefix;
  item.keycardPrice = payload.keycard;
  item.poolLid = payload.poolLid;
};
/*
export const addProducts = ($, payload) => {
  const index = payload.index;
  const products = payload.products;

  const item = $.cart.rentals[index];
  item.quantity = 1;
  item.products = [];
  item.guideCompleted = true;

  products.forEach((product) => {
    item.products.push(product);
  });
};
*/
export const completeSkipassGuides = ($) => {
  $.cart.skipasses.forEach((skipass) => {
    if (skipass.age) {
      skipass.guideCompleted = true;
      skipass.guideFullyCompleted = true;
    }
  });
};

export const confirmSkiPass = ($, data) => {
  completeSkipassGuides($);

  if (typeof data.deliveryTo !== 'undefined') {
    $.cart.deliveryTo = data.deliveryTo;
  }

  $.cart.skipasses.forEach((skipass) => {
    skipass.possibleAddons = [];
    skipass.deliveryType = data.type;
    skipass.site = data.site;
    if (skipass.guideFullyCompleted) {
      skipass.confirmed = true;
      skipass.date_arrival = data.date;
    }
  });

  refreshCart($);
};

export const addProduct = ($, payload) => {
  if (!$.cart.products) {
    $.cart.products = [];
  }

  const foundItem = $.cart.products.findIndex(el => el.poolId === payload.poolId);

  if (foundItem === -1) {
    const item = new ProductCartItem();
    item.quantity = payload.quantity;
    item.name = payload.name;
    item.poolId = payload.poolId;
    item.price = payload.price;
    item.confirmed = true;

    $.cart.products.push(item);
  } else {
    $.cart.products[foundItem].quantity += payload.quantity;
  }

  refreshCart($);
};
/*
export const addRentalAddon = ($, payload) => {
  const index = payload.index;
  const product = payload.product;

  const item = $.cart.rentals[index];
  item.addons.push(product);
};

export const removeRentalAddon = ($, payload) => {
  const index = payload.index;
  const product = payload.product;

  const item = $.cart.rentals[index];

  let theIndex = -1;
  item.addons.forEach((addon, i) => {
    if (addon.pool_lid === product.pool_lid) {
      theIndex = i;
    }
  });

  item.addons.splice(theIndex, 1);
};
*/
export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/skipass.js